import React from 'react';
import { DollarSign, CreditCard, TrendingUp, Receipt } from 'lucide-react';

const CSPBillingTab = ({ billingData }) => (
  <div className="space-y-6">
            {billingData ? (
              <>
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white">
                    <DollarSign className="h-8 w-8 mb-2" />
                    <p className="text-green-100 text-sm">Total Revenue</p>
                    <p className="text-3xl font-bold">${billingData.total_revenue?.toLocaleString()}</p>
                    <p className="text-green-100 text-xs">{billingData.billing_period}</p>
                  </div>
                  <div className="bg-white rounded-xl border shadow-sm p-6">
                    <Users className="h-8 w-8 text-blue-500 mb-2" />
                    <p className="text-gray-500 text-sm">Billing Customers</p>
                    <p className="text-3xl font-bold text-gray-900">{billingData.total_customers}</p>
                  </div>
                  <div className="bg-white rounded-xl border shadow-sm p-6">
                    <TrendingUp className="h-8 w-8 text-purple-500 mb-2" />
                    <p className="text-gray-500 text-sm">Avg Revenue/Customer</p>
                    <p className="text-3xl font-bold text-gray-900">
                      ${Math.round(billingData.total_revenue / Math.max(1, billingData.total_customers)).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-xl border shadow-sm p-6">
                  <h3 className="font-semibold text-gray-900 mb-4">Customer Billing Details</h3>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b">
                          <th className="text-left py-2 px-3">Customer</th>
                          <th className="text-left py-2 px-3">Tier</th>
                          <th className="text-right py-2 px-3">Devices</th>
                          <th className="text-right py-2 px-3">Data (GB)</th>
                          <th className="text-right py-2 px-3">Base Fee</th>
                          <th className="text-right py-2 px-3">Usage</th>
                          <th className="text-right py-2 px-3 font-bold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {billingData.billing_items?.map((item) => (
                          <tr key={item.customer_id} className="border-b hover:bg-gray-50">
                            <td className="py-2 px-3 font-medium">{item.customer_name}</td>
                            <td className="py-2 px-3">
                              <span className={`px-2 py-0.5 rounded text-xs ${
                                item.subscription_tier === 'enterprise' ? 'bg-purple-100 text-purple-700' :
                                item.subscription_tier === 'standard' ? 'bg-blue-100 text-blue-700' :
                                'bg-gray-100 text-gray-700'
                              }`}>
                                {item.subscription_tier}
                              </span>
                            </td>
                            <td className="py-2 px-3 text-right">{item.usage?.devices?.toLocaleString()}</td>
                            <td className="py-2 px-3 text-right">{item.usage?.data_gb}</td>
                            <td className="py-2 px-3 text-right">${item.charges?.base_fee}</td>
                            <td className="py-2 px-3 text-right">${(item.charges?.device_charges + item.charges?.data_charges).toFixed(2)}</td>
                            <td className="py-2 px-3 text-right font-bold">${item.charges?.total}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ) : (
              <div className="bg-white rounded-xl border shadow-sm p-12 text-center">
                <Receipt className="h-12 w-12 mx-auto mb-4 text-gray-300" />
                <p className="text-gray-500">Loading billing data...</p>
              </div>
            )}
          </div>
);

export default CSPBillingTab;
